<script>
  import {onMount, onDestroy} from "svelte";

  const viewMap = () => {
    try {
      let mapContainer = document.getElementById('map'), // 지도를 표시할 div
        mapOption = {
          center: new kakao.maps.LatLng(33.450701, 126.570667), // 지도의 중심좌표
          level: 3 // 지도의 확대 레벨
        };

      // 지도를 생성합니다
      let map = new kakao.maps.Map(mapContainer, mapOption);

      // 주소-좌표 변환 객체를 생성합니다
      let geocoder = new kakao.maps.services.Geocoder();

      // 주소로 좌표를 검색합니다
      geocoder.addressSearch('인천광역시 계양구 주부토로 501번길 38', function (result, status) {

        // 정상적으로 검색이 완료됐으면
        if (status === kakao.maps.services.Status.OK) {

          let coords = new kakao.maps.LatLng(result[0].y, result[0].x);

          let imageSrc = '/images/mappoint.png'; // 마커이미지의 주소입니다
          // let imageSize = new kakao.maps.Size(64, 69); // 마커이미지의 크기입니다
          let imageSize = new kakao.maps.Size(32, 35); // 마커이미지의 크기입니다
          // let imageOption = {offset: new kakao.maps.Point(32, 35)}; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

          // 마커의 이미지정보를 가지고 있는 마커이미지를 생성합니다
          let markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize);

          // 결과값으로 받은 위치를 마커로 표시합니다
          let marker = new kakao.maps.Marker({
            map: map,
            position: coords,
            image: markerImage
          });

          // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
          map.setCenter(coords);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }


  onMount(() => {
    // console.log('mount');
    viewMap();
  });
  onDestroy(() => {
    // console.log('cleanUp')
  });

  import SubHeader from "../components/SubHeader.svelte";

  let subHeader = {
    bg_pc: '/images/sub_find.png',
    bg_mo: '/images/sub_find_m.png',
    title: '매장안내',
    dsc: '지금 커피멘토를 찾아보세요.'
  }
</script>

<SubHeader { ...subHeader } />

<section class="find">
  <ul class="find__list">
    <li class="find__item">
      <span class="find__title">계산시장점 </span>
      <span class="find__address"> 인천광역시 계양구 주부토로 501번길 38</span>
    </li>
  </ul>

  <div class="find__selected">
    <div class="find__item">
      <span class="find__title">계산시장점 </span>
      <span class="find__address"> 인천광역시 계양구 주부토로 501번길 38</span>
    </div>
    <div class="find__map" id="map"></div>
  </div>
</section>
